// TODO(v2): move to env var or AppSettings model so admins can adjust.
// TODO(confirm): 2026-10-05 is a placeholder based on the fixed Quebec electoral calendar
// (first Monday of October every 4 years). Confirm the exact date before merging.
export const ELECTION_DATE = new Date('2026-10-05T00:00:00-04:00')
export const ELECTION_LABEL = 'Élection générale du Québec'

/**
 * Start of the current mandate — used as the anchor for the progress bar in
 * the home countdown hero. Anchored to the previous general election date
 * (Quebec fixed electoral calendar, first Monday of October 2022).
 */
export const MANDATE_START_DATE = new Date('2022-10-03T00:00:00-04:00')
